<form #callsQuotaDialog="ngForm" autocomplete="off">
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="callsQuota.name" maxlength="255" name="name">
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="fullWidth">
    <mat-label>Quota (minutes)</mat-label>
    <input matInput [(ngModel)]="callsQuota.quota" type="number" min="1" max="10000000" name="quota" [required]="true">
  </mat-form-field>

  <arm-form-title>Periodicity</arm-form-title>

  <mat-radio-group class="radio-option" [(ngModel)]="callsQuota.periodicity"
                   [ngModelOptions]="{standalone: true}" (change)="periodicityChange($event)">
    <div class="radio-options">
      <mat-radio-button color="primary" [value]="'DAILY'">Daily</mat-radio-button>

      <mat-radio-button color="primary" [value]="'WEEKLY'">
        Weekly
      </mat-radio-button>

      <ac-input-container label="Count from" *ngIf="callsQuota.periodicity === 'WEEKLY'" class="halfWidth count-from"
                          [required]="callsQuota.periodicity === 'WEEKLY' && !callsQuota.firstDayOfWeek"
                          [customError]="callsQuota.periodicity === 'WEEKLY' && !callsQuota.firstDayOfWeek ? 'Day of the week is required' : ''">
        <ac-select [acModel]="callsQuota.firstDayOfWeek"
                   (acModelChange)="callsQuota.firstDayOfWeek = $event; periodicityChange($event)"
                   [searchable]="true"
                   [items]="daysOptions">
        </ac-select>
      </ac-input-container>

      <mat-radio-button color="primary" [value]="'MONTHLY'">
        <mat-label class="label-inside-complex-option">Monthly</mat-label>
      </mat-radio-button>

      <ac-input-container label="Count from" *ngIf="callsQuota.periodicity === 'MONTHLY'" class="halfWidth count-from"
                          [required]="callsQuota.periodicity === 'MONTHLY' && !callsQuota.firstDayOfMonth"
                          [customError]="callsQuota.periodicity === 'MONTHLY' && !callsQuota.firstDayOfMonth ? 'Day of the month is required' : ''">
        <ac-select [acModel]="callsQuota.firstDayOfMonth"
                   (acModelChange)="callsQuota.firstDayOfMonth = $event; periodicityChange($event)"
                   [searchable]="true"
                   [items]="dateOptions">
        </ac-select>
      </ac-input-container>
    </div>
  </mat-radio-group>

  <mat-hint *ngIf="showCountFromDayNotice()"
            class="count-from-day-notice">
    Months with less days will be counted until the last day of the month
  </mat-hint>

  <mat-checkbox class="block-calls" name="blockCalls" color="primary" [(ngModel)]="callsQuota.blockCalls">Block Calls</mat-checkbox>
</form>
